const type = 'advanced'
const path = 'client/html'
const name = 'app.js'
const fullPath = `${path}/${name}`

const conditions = [
  {
    parameter: 'buttons',
    type: 'includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, fullPath, conditions }
